import { Fragment, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import NewProduct from "./newproduct";

export default function ProductDetails(props) {
    const { id } = props

    const [product, setProduct] = useState()

    let products = useSelector(state => state.product.products)



    useEffect(() => {

        setProduct(() => products.filter(product => product.id == id))

    }, [products])


    if (!product) {
        <Skeleton count={50} />
    }

    console.log(product)

    return <Fragment>
        {product && <NewProduct product={product[0]} />}
    </Fragment>
}